import { render, staticRenderFns } from "./AllocationsByFacilities.vue?vue&type=template&id=0b0137e7&scoped=true"
import script from "./AllocationsByFacilities.vue?vue&type=script&lang=js"
export * from "./AllocationsByFacilities.vue?vue&type=script&lang=js"
import style0 from "./AllocationsByFacilities.vue?vue&type=style&index=0&id=0b0137e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0137e7",
  null
  
)

export default component.exports